import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const IconWrapper = styled.div `
  padding: 0;
  margin: 0;
  height: ${(props) => props.size + 5}px !important;
  width: ${(props) => props.size + 5}px !important;
  min-width: ${(props) => props.size + 5}px !important;
  border-radius: 50%;
  display:flex;
  align-items: center;
  justify-content: center;
  color:${({ theme, color }) => color || theme.button.background};
  background-color: #fff
`;
const Icon = styled.div `
  display: inline-block;
  font-size: ${(props) => props.size}px;
`;
export const UserAvatar = (props) => {
    return (React.createElement(IconWrapper, { size: props.size },
        React.createElement(Icon, { size: props.size },
            React.createElement(FontAwesomeIcon, { title: 'User Avatar', icon: ["fas", "user-circle"], "aria-labelledby": "" }))));
};
